import {
  Users,
  BookOpen,
  School,
  ShoppingCart,
  Briefcase,
  Building2,
  Settings,
} from "lucide-react";
import { cn } from "../../lib/utils";
import { useViewMode } from "../contexts/ViewModeContext";
import {
  ACCENT_ACTIVE_CLASS,
  type ViewModeDef,
} from "../../gedoba/view-modes/viewModePacks";

const ICONS = {
  users: Users,
  book: BookOpen,
  school: School,
  cart: ShoppingCart,
  briefcase: Briefcase,
  building: Building2,
  settings: Settings,
} as const;

export default function ViewModeToggle() {
  const { viewMode, setViewMode, portalPack } = useViewMode();
  const modes = portalPack.modes;

  if (!modes.length) return null;

  return (
    <div
      className="flex items-center rounded-lg bg-button-bg p-0.5 border border-button-border"
      role="group"
      aria-label={`Switch views (${portalPack.label})`}
    >
      {modes.map((mode: ViewModeDef) => {
        const Icon = ICONS[mode.icon] || Users;
        const active = viewMode === mode.id;
        return (
          <button
            key={mode.id}
            type="button"
            onClick={() => setViewMode(mode.id)}
            className={cn(
              "flex items-center gap-2 px-2.5 py-1.5 rounded-md text-xs font-medium transition-all duration-200 border-2 flex-none",
              active
                ? ACCENT_ACTIVE_CLASS[mode.accent]
                : "border-transparent text-content-text-muted hover:bg-button-bg-hover hover:text-content-text",
            )}
            title={mode.title}
            aria-label={mode.title}
            aria-pressed={active}
            data-view-mode={mode.id}
          >
            <Icon className="w-3.5 h-3.5" />
            <span>{mode.label}</span>
          </button>
        );
      })}
    </div>
  );
}
